import Swiper from 'swiper';
import SameSizedCards from '../modules/same_sized_cards';
import Form from '../modules/forms/form';
import copyToClipboard from '../util/copyToClipboard';
import debounce from '../util/debounce';
import Components from '../autoload/_components';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import datepickerFactory from 'jquery-datepicker';
import flatpickr from 'flatpickr';
import moment from 'moment';
import Utils from '../util/utils';


datepickerFactory($);
moment();
export default {
    init() {
        // JavaScript to be fired on all pages
        // var intlTelInput = '';


    },
    finalize() {

        // JavaScript to be fired on all pages, after page specific JS is fired
        this.setDefaults();
        Form.init();
        SameSizedCards.init();
        Components.init();
        this.addEvents();
        this.initSwipers();
        this.initTags();
        lazySizes.init();
        this.test();
        this.country();
        this.filter();
        this.selection();
        // intlTelInput.init();
        this._onToggleCheck();
        this._onClickScrollToDiv();
        this._onClickDropdown();
        this._closeOverlay();
        this.terminal();
        this._makeTabsSticky();
        // this._initMap();
        this._initCalender();
    },


    setDefaults() {
        this.jHtml = $(document.body).parent();

         $('#myselect').select2({
            width: '100%',
            placeholder: 'Select an Option',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        }).on('change', function() {
            if ($(this).hasClass('map-level')) {
                $(this).closest('form').submit();
            }
        });
        $('.select2-selection__rendered').hover(function() {
            $(this).removeAttr('title');
        });
        $(window).bind('load', function() {
            console.log('done');
        });
        $('.jsSelect2').select2({});

    },
    _onHomeBannerSubmit: function() {
        return this.searchBanner();
    },
    _onHomeBannerDropdownChange: function() {
        var toSubmit = this.searchBanner();
        if (toSubmit) {
            var jForm = $('#jsBannerSearch');
            jForm.submit();
        }
    },
    searchBanner() {
        var textVal = $('#jsHomeBannerTxtSearch').val();
        // var txtSearch =  $('#jsHomeBannerTxtSearch').val();
        // if(txtSearch.length == 0){
        //     return false;
        // }
        if (textVal.length) {
            $('#jsBannerSearch').attr('action', '/schedule/cruise/');
        } 
        else {
            $('#jsBannerSearch').attr('action', '/schedule/cruise/');

        }

        return true;
    },
    test() {
        this.jHtml = $(document.body).parent();
        $('#select-search').select2({
            width: '100%',
            //placeholder: 'Select an Option',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
    },
    terminal() {
        this.jHtml = $(document.body).parent();
        $('#select-terminal').select2({
            width: '100%',
            //placeholder: 'Select an Option',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
    },
    selection() {
        this.jHtml = $(document.body).parent();
        $('.selecttwo').select2({
            width: '100%',
            //placeholder: 'Select an Option',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
    },
    filter() {
        this.jHtml = $(document.body).parent();
        $('#select-filter').select2({
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
        $('#select-filter1').select2({
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
        $('#select-filter2').select2({
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
        $('.jsCruiseSelect2').select2({
            width: '100%',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
    },
    country() {
        this.jHtml = $(document.body).parent();
        $('#select-country').select2({
            width: '100%',
            //placeholder: 'Select an Option',
            allowClear: false,
            minimumResultsForSearch: Infinity,
        });
    },
    addEvents() {
        $('select[name="destinations"]').on('change', function() {
            $(this).closest('form').submit();
        });

        $('#select-terminal').on('change', function() {
        // Grab the value of the selected option and redirect
        var selectedUrl = $(this).val();
        if (selectedUrl) {
            window.location.href = selectedUrl;
        }

        Utils.showLoaderOnLoad(true);
        setTimeout(function() {
            Utils.showLoaderOnLoad(false);
        }, 5000);
    });
        $('#myTab a').on('click', function (e) {
            e.preventDefault()
            $(this).tab('show')
          })

        $('.dropdown_mobile').on('click', function() {
            var icon = $(this).find('.mobile_icon');

            if ($(this).hasClass('show')) {
                icon.addClass('rotate');
            } else {
                icon.removeClass('rotate');
            }
        });

        $(window).scroll(debounce($.proxy(this._onWinScroll, this), 100));

        $('.jsReferralGotoDashboard').on('click', function() {
            location.href = 'https://carbonateapp.com/dashboard';
        });
        // for milestone
        $('.milestone-bottom-tabs a').on('click', function(e) {
            e.preventDefault();
            var href = $(this).attr('href');
            $(href).tab('show');
        });
        //read more-less
        // $(".location table tbody tr td:first-child").addClass("black");
        $(document).ready(function() {
            var showChar = 1000;

            $('.milestones__content-wrapper').each(function() {
                var content = $(this).text().length;
                var block = $(this).parent();
                var button = block.find('.moreless-button');
                if (content > showChar) {
                    $(this).addClass('showless');
                    button.removeClass('g-none');


                } else {
                    $(this).removeClass('showless');

                    button.addClass('g-none');
                }

            });


        });

        $('.moreless-button').on('click', function(e) {
            e.preventDefault();

            var jBlock = $(this).parent();
            var jContent = jBlock.find('.milestones__content-wrapper');
            if ($(this).text() == 'Read more') {
                $(this).text('Read less')
                    //   jContent.addClass('showmore');
                jContent.addClass('showmore');

            } else {
                $(this).text('Read more')
                jContent.removeClass('showmore');

            }
        });
        $(document).ready(function(){
            $('#jsClickCruiseFormSubmit').css('cursor', 'pointer');
            $('#jsClickFerryFormSubmit').css('cursor', 'pointer');
            $('#jsClickCruiseFormSubmit').on('click', function() {
                $('#JsCruiseFrom').submit();
            });
            $('#jsClickFerryFormSubmit').on('click', function() {
                $('#JsFerryFrom').submit();
            });
            
            $('#cruiseSerchInput').keypress(function (e) {
                if (e.which == 13) {
                   $('#JsCruiseFrom').submit();
                }
            });
        });
        
        $('.jsSearchRengeCruise').on('change', function() {
            var val = $('.jsSearchRengeCruise').val();
            var parts = val.split('to');
            var startTime, endTime;
            startTime = parts[0];
            endTime = parts[1];
            if (startTime.length != '' && endTime.length != '') {
                $('#JsCruiseFrom').submit();
            }
        });
        // datepicker
        if ($('.datepicker').length > 0) {
            var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            $('.datepicker').datepicker({
                minDate: today,
                dateFormat: 'DD,dd MM yy',
 
            });
            $('.calender-icon').on('click', function(e) {
                e.preventDefault();
                $('.datepicker').datepicker('show');
            });
        }
        // if ($('#calendar-range').length > 0) {
        //        $('.calender-icon-range').on('click', function(e) {
        //         e.preventDefault();
        //         // me._initCalender();
        //         var maxMonthLimit=$('#calendar-range').data('maxmonth');
     
        //         let curDate = new Date();
        //         var futureDate = new Date(curDate.setMonth(curDate.getMonth()+ maxMonthLimit));
        
        
        
        //         var calender = flatpickr('#calendar-range', {
        //             'mode': 'range',
        //             minDate: 'today',
        //             'dateFormat': 'd M Y',
                   
        //             maxDate: futureDate,
        //             'monthSelectorType': 'static',
        //             'yearSelectorType': 'static',
        
        //         });
        //         calender.open();
        //     });

        // }
        $('textarea#inq_msg').on('keyup', function() {
            var maxlen = $(this).attr('maxlength');

            var length = $(this).val().length;
            if (length > (maxlen - 10)) {
                $('#textarea_message').text('max length ' + maxlen + ' characters only!')
            } else {
                $('#textarea_message').text('');
            }
        });

        $('textarea#inq_desc').on('keyup', function() {
            var maxlen = $(this).attr('maxlength');

            var length = $(this).val().length;
            if (length > (maxlen - 10)) {
                $('#textarea_description').text('max length ' + maxlen + ' characters only!')
            } else {
                $('#textarea_description').text('');
            }
        });

        //Check to see if the window is top if not then display button
        $(window).scroll(function() {
            if ($(this).scrollTop() > 200) {
                $('.scrollToTop').fadeIn();
            } else {
                $('.scrollToTop').fadeOut();
            }
        });

        $('#jsRedirectTerminal').click(function() {
            var valDrop = $('.JsdropDownShowTerminal').val();
            window.location.href = '/terminal/' + valDrop
        });

        //Click event to scroll to top
        $('.scrollToTop').click(function() {
            $('html, body').animate({ scrollTop: 0 }, 300);
            return false;
        });

        if ($('.user-guide-detail__steps').length > 0) {
            $('.user-guide-detail__steps').magnificPopup({
                delegate: '.user-guide-detail__step-img-wrapper', // child items selector, by clicking on it popup will open
                type: 'image',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '<span class="mfp-counter">Step %curr%</span>', // markup of counter
                },
                image: {
                    // options for image content type
                    titleSrc: function() {
                        return '';
                    },
                },
                midClick: true,

                // Delay in milliseconds before popup is removed
                removalDelay: 300,

                // Class that is added to popup wrapper and background
                // make it unique to apply your CSS animations just to this exact popup
                mainClass: 'mfp-fade',

                // other options
            });
        }
        $('#submitBannerSearch').click(function() {
            $('#jsBannerSearch').submit();
        });
        if ($('.btn-popup').length > 0) {
            $('.open-popup-link').magnificPopup({
                type: 'inline',
                midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
                mainClass: 'mfp-fade',
            });
        }

        $(document).ready(function() {
            $('.js-example-basic-single').select2();
        });
        // $('.signup-exit').addClass('d-none');

        $('.jsLeftNavLink').on('change', function(e) {
            var jTarget = $(e.delegateTarget);
            location.href = jTarget.find(':selected').data('href');
        });

        this._checkScrollAndUpdateTop();
        if ($(window).width() < 767) {
            $('#scroll__top').click(function() {
                // e.preventDefault();
                $('html, body').animate({
                    scrollTop: '0',
                }, 400);
            });
        } else {
            $('#scroll__top').hide();
        }
        $('.thanks__urlcopy').on('click', function() {
            copyToClipboard($('.thanks__url').html().trim());
            $('.thanks__urlcopy').addClass('active');

            setTimeout(function() {
                $('.thanks__urlcopy').removeClass('active')
            }, 3000);

        });


      
     
    
        // ---- js for tenant-list page------
        $(document).ready(function() {
            $('.jsCatLink').click(function() {
                var x = document.getElementsByClassName('tenant_form');
                // Form submission
                $('#features').val($(this).attr('data-value'));
                x[0].submit();

            });
        });

        if ($(window).width() < 991) {

            var list = $('.weather__lists li:gt(1)');
            list.hide();
            $('.banner-schedule__more').click(function() {
                list.slideToggle(400);
                $('.banner-schedule__more').addClass('hide');
                $('.banner-schedule__less').removeClass('hide');
                return false;
            });
            $('.banner-schedule__less').click(function() {
                list.slideToggle(400);
                $('.banner-schedule__more').removeClass('hide');
                $('.banner-schedule__less').addClass('hide');
                return false;
            });
        }

        $('#inquiry_type').ready(function() {
            if (this.value == 'Lost & Found') {
                $('#inquiry-form__feild-date-time').append('<div class="row " ><div class="col-md-6 inquiry-form_feild_hide"><div class="form__input-wrapper" ><label for="date" class="form__label label text-uppercase">DATE (WHEN THE ITEM WAS LOST) *</label><input type="date" class="form__input jsDatePicker" name="date"></div></div><div class="col-md-6 inquiry-form_feild_hide"><div class="form__input-wrapper"><label for="time" class="form__label label text-uppercase">TIME *</label><input type="time" class="form__input" name="time" /></div></div></div>');
                $('#inquiry-form__feild-description').append('<div class="form__input-wrapper row inquiry-form_feild_hide" ><div class="col"><label for="inq_desc" class="form__label label text-uppercase">DESCRIPTION OF INCIDENT *</label><textarea name="inq_desc" id="" cols="30" rows="5"></textarea></div></div>');
                $('#inquiry-form__feild-tot').empty();
                $('#inquiry-form__feild-message').empty();
            } else {
                $('#inquiry-form__feild-date-time').empty();
                $('#inquiry-form__feild-description').empty();
                $('#inquiry-form__feild-tot').append('<div class="row form__input-wrapper" ><div class="col"><label for="travel_inquiry" class="form__label label text-uppercase">TYPE OF TRAVEL *</label><select name="travel_inquiry" class="select"><option value="ferry">Ferry</option><option value="cruise">Cruise</option><option value="others">Others</option></select></div></div>');
                $('#inquiry-form__feild-message').append('<div class="form__input-wrapper row"><div class="col"><label for="inq_msg" class="form__label label text-uppercase">MESSAGE *</label><textarea name="inq_msg" id="" cols="30" rows="5"></textarea></div></div>');
            }
            if (this.value == 'Leasing Opportunities' || this.value == 'Media Enquiry') {
                $('#inquiry-form__feild-tot').empty();
            }
        });

        $('#inquiry_type').on('change', function() {
            if (this.value == 'Lost & Found') {
                $('#inquiry-form__feild-date-time').append('<div class="row " ><div class="col-md-6 inquiry-form_feild_hide"><div class="form__input-wrapper" ><label for="date" class="form__label label text-uppercase">DATE (WHEN THE ITEM WAS LOST) *</label><input type="date" class="form__input jsDatePicker" name="date"></div></div><div class="col-md-6 inquiry-form_feild_hide"><div class="form__input-wrapper"><label for="time" class="form__label label text-uppercase">TIME</label><input type="time" class="form__input" name="time" /></div></div></div>');
                $('#inquiry-form__feild-description').append('<div class="form__input-wrapper row inquiry-form_feild_hide" ><div class="col"><label for="inq_desc" class="form__label label text-uppercase">DESCRIPTION OF INCIDENT *</label><textarea name="inq_desc" id="" cols="30" rows="5"></textarea></div></div>');
                $('#inquiry-form__feild-tot').empty();
                $('#inquiry-form__feild-message').empty();
            } else {
                $('#inquiry-form__feild-date-time').empty();
                $('#inquiry-form__feild-description').empty();
                $('#inquiry-form__feild-tot').empty();
                $('#inquiry-form__feild-message').empty();
                $('#inquiry-form__feild-tot').append('<div class="row form__input-wrapper" ><div class="col"><label for="travel_inquiry" class="form__label label text-uppercase">TYPE OF TRAVEL *</label><select name="travel_inquiry" class="select"><option value="ferry">Ferry</option><option value="cruise">Cruise</option><option value="others">Others</option></select></div></div>');
                $('#inquiry-form__feild-message').append('<div class="form__input-wrapper row"><div class="col"><label for="inq_msg" class="form__label label text-uppercase">MESSAGE *</label><textarea name="inq_msg" id="" cols="30" rows="5"></textarea></div></div>');
            }
            if (this.value == 'Leasing Opportunities' || this.value == 'Media Enquiry') {
                $('#inquiry-form__feild-tot').empty();
            }
        });

        $('#jsBannerSearch').on('submit', $.proxy(this.searchBanner, this));
        // $('.jsHomeBannerSelect').on('change', $.proxy(this._onHomeBannerDropdownChange, this));

        var me = this;
        $(window).scroll(function() {
            me._handleHeaderScroll();
            me._makeTabsSticky();
        });

        $(window).resize(function() {
            me._handleHeaderScroll();
            me._makeTabsSticky();
        });

        // for header padding
        $(window).load(function() {
            me._handleHeaderScroll();
            me._updatePagePadding();
       });
       $(document).ready(function() {
         me._handleHeaderScroll();
         me._updatePagePadding();
       });
       $(window).resize(function() {
         me._handleHeaderScroll();
         me._updatePagePadding();
       });
       

    },
    initSwipers() {
        // Horizontal Swipers
        new Swiper($('.jsSwiper.jsHorizontalSwiper')[0], {
            autoplay: {
                delay: 1000000,
            },
            slidesPerView: 'auto',
            loop: false,
            speed: 600,
            freeMode: true,
            observer: true,
            observeParents: true,
        });
       
        new Swiper($('.jsTenant')[0], {
            autoplay: {
                delay: 2500,
            },
            slidesPerView: '1',
            spaceBetween: 20,
            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
            loop: true,

        });
    },
   
    initTags() {
        if ($('.jsSelectMultiple.jsSelectTags').length > 0) {
            // let select2Instance;
            //$('.jsSelectMultiple.jsSelectTags').select2();

            $('.jsSelectMultiple.jsSelectTags').select2({
                multiple: true,
                createTag: function() {
                    return null;
                },
            });
            // Patch to clear the selections in the begining
            // select2Instance.val(null).trigger('change');
        }
    },



    _onWinScroll: function() {
        this._checkScrollAndUpdateTop();
    },
    _checkScrollAndUpdateTop: function() {
        if ($(window).scrollTop() > 300) {
            if ($(window).width() < 767) {
                $('#scroll__top').show();
            }
        } else {
            $('#scroll__top').hide();
        }
    },
    _onToggleCheck: function() {
        if ($('#JSswitchChengeble').length > 0) {
            $('.departure-label-check ').addClass('disable');
            if ($('#JSswitchChengeble').is(':checked')) {
                $('.arrival-label-check').addClass('disable');
                $('.departure-label-check').removeClass('disable');
            } else {
                $('.arrival-label-check').removeClass('disable');
                $('.departure-label-check').addClass('disable');
            }
        }


    },
    _onClickScrollToDiv: function() {
        if ($('.milestones').length > 0) {
            $('.milestone-bottom-tabs a').on('click', function(e) {
                e.preventDefault();
                if ($('.milestones__wrapper').length > 0) {
                    var scrolled = $('.milestones__wrapper').offset().top;
                    $('html, body').animate({
                        scrollTop: scrolled,
                    }, 500);
                }
            });
        }

        if ($('.tab-header').length > 0) {
            var $navLinks = $('.tab-scrollspy__nav-item a');
            var isClickScrolling = false;

            $navLinks.on('click', function(e) {
                var jBlock = $(this).attr('href');
                if ($(jBlock).length > 0) {
                    e.preventDefault();
                    var headerHeight = $('.page__header-shadow').outerHeight() || 0;
                    var tabHeaderHeight = $('.tab-header').outerHeight() || 0;
                    var height = headerHeight + tabHeaderHeight;

                    $navLinks.removeClass('active');
                    $(this).addClass('active');

                    isClickScrolling = true;
                    $('html, body').stop().animate({
                        scrollTop: $(jBlock).offset().top - height + 1,
                    }, 300, function() {
                        setTimeout(function() {
                            isClickScrolling = false;
                        }, 50);
                    });
                }
            });

            $(window).on('scroll', function() {
                if (isClickScrolling) return;

                var scrollTop = $(window).scrollTop();
                var headerHeight = $('.page__header-shadow').outerHeight() || 0;
                var tabHeaderHeight = $('.tab-header').outerHeight() || 0;
                var offset = headerHeight + tabHeaderHeight + 20;

                var activeLink = null;

                if (scrollTop + $(window).height() >= $(document).height() - 50) {
                    activeLink = $navLinks.last();
                } else {
                    $navLinks.each(function() {
                        var targetId = $(this).attr('href');
                        var $targetSection = $(targetId);
                        if ($targetSection.length > 0) {
                            var targetTop = $targetSection.offset().top;
                            if (scrollTop >= targetTop - offset) {
                                activeLink = $(this);
                            }
                        }
                    });
                }

                if (activeLink) {
                    if (!activeLink.hasClass('active')) {
                        $navLinks.removeClass('active');
                        activeLink.addClass('active');
                    }
                } else {
                    var $firstLink = $navLinks.first();
                    if (!$firstLink.hasClass('active')) {
                        $navLinks.removeClass('active');
                        $firstLink.addClass('active');
                    }
                }
            });
        }
    },
   


    _onClickDropdown: function() {
        $('.filter-input').on('click', function(e) {
            e.preventDefault();
            $('.banner-schedule__searchform-filter').addClass('show');

            $('.overlay').addClass('show');
            $('.overlay').removeClass('hide');

        });

    },
    _closeOverlay: function() {
        $('.overlay').on('click', function(e) {
            e.preventDefault();
            $('.overlay').addClass('hide');
            $('.overlay').removeClass('show');
            $('.banner-schedule__searchform-filter').removeClass('show');

        });
    },
    _makeTabsSticky: function() {
        var topbarHeight = $('.page-topbar').length > 0 && !$('.page-topbar').hasClass('d-none') ? ($('.page-topbar').outerHeight() || 0) : 0;
        var navbarHeight = $('.page__header-shadow').outerHeight() || 0;
        
        var tabHeaderHeight = $('.tab-header').height() || 0;
        var offsetHeight = topbarHeight + navbarHeight;
        var height = offsetHeight + tabHeaderHeight + 50;
        $('body').attr('data-bs-offset', height);

        if ($('.header').hasClass('position-fixed')) {
            $('.tab-header').addClass('fixed-header');
            $('.fixed-header').css('top', navbarHeight + 'px');
        } else {
            $('.tab-header').removeClass('fixed-header');
            $('.tab-header').css('top', '0');
        }

        // Dynamically set sticky image top offset to align exactly below the sticky tab-header
        var stickyImageTop = navbarHeight + tabHeaderHeight;
        $('.terminal-transport__img.sticky-top').css('top', stickyImageTop + 'px');
    },
    _updatePagePadding: function() {    
        var $header = $('.header');
        var $content = $('.page__content');
        
        if ($header.hasClass('position-fixed')) {
            var navbarHeight = $('.page__header-shadow').outerHeight() || 0;
            $content.css('padding-top', navbarHeight + 'px');
        } else {
            $content.css('padding-top', '0');
        }
    },
    _handleHeaderScroll: function() {
        var scrollTop = $(window).scrollTop();
        var $topbar = $('.page-topbar');
        var $header = $('.header');

        if ($topbar.length > 0) {
            var topbarHeight = $topbar.data('original-height');
            if (!topbarHeight) {
                topbarHeight = $topbar.outerHeight() || 0;
                if (topbarHeight > 0) {
                    $topbar.data('original-height', topbarHeight);
                }
            }
            if (!topbarHeight) topbarHeight = 40;

            if (scrollTop >= topbarHeight) {
                if (!$header.hasClass('position-fixed')) {
                    $topbar.addClass('d-none');
                    $header.addClass('position-fixed');
                    this._updatePagePadding();
                    this._makeTabsSticky();
                }
            } else {
                if ($header.hasClass('position-fixed')) {
                    $topbar.removeClass('d-none');
                    $header.removeClass('position-fixed');
                    this._updatePagePadding();
                    this._makeTabsSticky();
                }
            }
        } else {
            $header.addClass('position-fixed');
            this._updatePagePadding();
            this._makeTabsSticky();
        }
    },
    _initCalender:function(){
        var maxMonthLimit=$('#calendar-range').data('maxmonth');
     
        let curDate = new Date();
        var futureDate = new Date(curDate.setMonth(curDate.getMonth()+ maxMonthLimit));



         flatpickr('#calendar-range', {
            'mode': 'range',
            minDate: 'today',
            'dateFormat': 'd M Y',
           
            maxDate: futureDate,
            'monthSelectorType': 'static',
            'yearSelectorType': 'static',

        });
        
    },
    




};


// WEBPACK FOOTER //
// ./scripts/routes/common.js